import { useMemo } from "react";
import { safeParseJson, sanitizeAdditionalUserData } from "../utils/inputSanitizers";

export const getAdditionalUserData = (rawValue) => {
  const source = rawValue ?? localStorage.getItem("additionalUserData") ?? "{}";
  return sanitizeAdditionalUserData(safeParseJson(source, {}));
};

const useAdditionalUserData = (rawValue) => {
  return useMemo(() => getAdditionalUserData(rawValue), [rawValue]);
};

export default useAdditionalUserData;
